import { ChangeDetectionStrategy, Component, computed, forwardRef } from '@angular/core';
import { NodeViewComponent } from '@examdojo/core/tiptap';
import { StopPropagationDirective } from '@examdojo/core/stop-propagation';
import { TiptapNodeViewContentDirective } from 'ngx-tiptap';
import { v4 as uuid } from 'uuid';
import { AccordionBlock, ContentBlockType } from '../../../model';
import { DragWithHandleOnlyDirective } from '../drag-with-handle-only.directive';
import { ACCORDION_PANEL_NODE_NAME, DEFAULT_ACCORDION_PANEL_TITLE } from './accordion.model';

@Component({
  selector: 'dojo-accordion',
  standalone: true,
  imports: [TiptapNodeViewContentDirective, StopPropagationDirective],
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
  hostDirectives: [DragWithHandleOnlyDirective],
  providers: [
    {
      provide: NodeViewComponent,
      useExisting: forwardRef(() => AccordionComponent),
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccordionComponent extends NodeViewComponent<AccordionBlock> {
  readonly isEditable = computed(() => this.editor().isEditable);
  readonly customCss = this.getProp('custom_css');

  override getDefaults = (): AccordionBlock => ({
    id: uuid(),
    type: ContentBlockType.Accordion,
    panels: [],
  });

  addPanel(): void {
    const editor = this.editor();
    const pos = this.getPos()();
    const node = this.node();

    // Insert a new accordionPanel at the end of the accordion's content
    const insertPos = pos + node.nodeSize - 1;
    editor
      .chain()
      .insertContentAt(insertPos, {
        type: ACCORDION_PANEL_NODE_NAME,
        attrs: { title: DEFAULT_ACCORDION_PANEL_TITLE },
        content: [{ type: 'paragraph' }],
      })
      .run();
  }
}
